import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataFeedService } from '../../../shared/api/datafeed.service';
import { IClient } from '../../../core/models/clients.models';
import { ISalesRep } from '../../../core/models/datafeed.models';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { ROLES } from '../../../core/helpers/constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ClientsApiService } from '../../clients/clients.apiservice';

@Component({
  selector: 'app-dms-change-form',
  templateUrl: './dms-change-form.component.html',
  styleUrls: ['./dms-change-form.component.scss']
})
export class DmsChangeFormComponent implements OnInit {
  @Input() clientId?: string;
  dmsForm: FormGroup;
  dmsOptions: ISalesRep[] = [];
  allClients: IClient[] = [];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private fb: FormBuilder,
    private dataFeedService: DataFeedService,
    private clientService: ClientsApiService,
    public activeModal: NgbActiveModal,
    private http: HttpClient
  ) {
    this.dmsForm = this.fb.group({
      FormType: ['Change DMS'],
      clientId: ['', Validators.required],
      NewDMS: ['', Validators.required],
      Notes: ['']
    });
    this.dataFeedService.getAllUsersWithRole(ROLES.DMS.Code)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.good) {
          this.dmsOptions = response.data.map((i: any) => ({ ...i, fullName: i.firstName + ' ' + i.lastName }));
        }
      });
  }

  ngOnInit() {
    if (this.clientId) {
      this.clientService.getClientDetails(this.clientId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.allClients = [response.data];
          this.dmsForm.get('clientId')?.setValue(this.clientId);
        });
    } else {
      this.dataFeedService.getAllClients()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.good) {
          this.allClients = response.data.map((i: any) => ({ ...i, fullName: i.firstName + ' ' + i.lastName }));
        }
      });
    }
  }

  onSubmit() {
    if (this.dmsForm.valid) {
      const formData = this.dmsForm.value;
      this.dmsForm.disable();
      this.http.post(`${environment.apiBaseUrl}/dmschange`, formData)
        .subscribe({
          next: (response) => {
            console.log('Form submitted successfully:', response);
            this.activeModal.close(response);
          },
          error: (error) => {
            console.error('Error submitting form:', error);
            this.dmsForm.enable();
          }
        });
    }
  }

  close() {
    this.activeModal.dismiss();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
